// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-wrap[data-v-c6bdcae2] {\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: space-between;\n}\n", ""]);
// Exports
module.exports = exports;
